var map = {
	"./18PW.png": 64913,
	"./19PW.png": 26754,
	"components/Catalog/PW/img/inserDoor/ds/dsPlusGrafit/18PW.png": 64913,
	"components/Catalog/PW/img/inserDoor/ds/dsPlusGrafit/19PW.png": 26754
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19646;